import React from "react";
import {ST} from "../global/SystemText";

/*
 * Výber variantu (typu) produktu v zozname produktov – téma v2 (mock docs/redesign/mock-d-vyber-variantu.html).
 * V1 renderuje pôvodný <select className="type-select"> priamo v ProductTile / ProductRow.
 */

export function isThemeV2() {
    return document.documentElement.classList.contains("theme-v2");
}

// "4 varianty", "6 variantov" (ukazuje sa len pri 2 a viac variantoch)
export function variantsCountText(count) {
    return count + " " + (count >= 5 ? ST.getOr("variants_many", "portal", "variantov") : ST.getOr("variants_few", "portal", "varianty"));
}

export function VariantBadge({types, className}) {
    if (!types || types.length < 2) {
        return null;
    }
    return (
        <span className={"variant-badge " + (className || "")}>
            <i className="icon icon-stack2"/> {variantsCountText(types.length)}
        </span>
    );
}

// v2: pri 2 a viac variantoch výber, pri jedinom variante nie je čo vyberať – len jeho obj. číslo
// (ako pri produkte bez variantov)
export function VariantChoice({types, orderOur, ...selectProps}) {
    return types.length > 1 ? <VariantSelect types={types} {...selectProps}/> : (types[0].orderOur || orderOur);
}

export default function VariantSelect({types, value, onChange, id, compact}) {
    const many = types.length > 1;
    return (
        <div className={"variant-picker" + (compact ? " variant-picker-compact" : "")}>
            <label className="variant-label" htmlFor={id}>
                {many && !compact ?
                    <span>{ST.getOr("select_variant", "portal", "Vyberte variant")} <span className="variant-count">({types.length})</span></span>
                    :
                    ST.getOr("variant", "portal", "Variant")}
            </label>
            <div className="variant-select-wrap">
                <select id={id} className="type-select variant-select" value={value} onChange={onChange}>
                    {types.map((element, index) => (
                        <option key={"option" + index} value={index}>{element.name}{element.orderOur ? " — " + element.orderOur : ""}</option>
                    ))}
                </select>
            </div>
        </div>
    );
}
